import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import EventList from "./EventList";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 20,
  },
}));

const CourseSchedule = (props) => {
  const classes = useStyles();
  return (
    <Grid container spacing={3} className={classes.root}>
      <EventList category="All" />
    </Grid>
  );
};

export default CourseSchedule;
